import { cn } from '@/lib/utils'
import ArmorTypes from './RosterStats/ArmorTypes'
import CountByClass from './RosterStats/CountByClass'
import CountByRole from './RosterStats/CountByRole'
import TotalCharacters from './RosterStats/TotalCharacters'

type Props = {
  forceGrid?: boolean
  className?: string
}

const RosterStats = ({ forceGrid = false, className = '' }: Props) => {
  return (
    <div className={forceGrid ? '' : 'max-xl:pt-4 xl:border-l-2 xl:pl-4'}>
      {forceGrid ? null : <h4 className='mb-2 xl:hidden'>Setup</h4>}
      <div
        className={cn(
          'max-sm:grid-cols-1 max-md:grid-cols-2 gap-2',
          forceGrid
            ? 'grid grid-cols-3'
            : 'max-xl:grid max-xl:grid-cols-3 xl:flex xl:flex-col',
        )}
      >
        <div className='flex flex-col gap-2 grow'>
          <TotalCharacters className={className} />
          <CountByRole className={className} />
        </div>

        <div className='flex flex-col gap-2 [&>div]:grow grow'>
          <ArmorTypes className={className} />
        </div>

        <div className='grow'>
          <CountByClass className={className} />
        </div>
      </div>
    </div>
  )
}

export default RosterStats
